import axios from 'axios';

const httpClient = axios.create({
  timeout: 90000,
});

class AuctionCore {
  constructor() {
    this.endpoint = window?.globalConfig.auctionCore;
    this.membershipEndpoint = window?.globalConfig.membership;
  }

    initInterceptor = (token) => {
      httpClient.interceptors.request.use((request) => {
        const { data } = request;
        if (data && !data.sessionToken && token) {
          request.data.sessionToken = token;
        }
        return request;
      });
    };

    authSession = (token) => {
      this.initInterceptor(token);
      return httpClient.post(`${this.endpoint}/api/AuthenticateSessionToken`, {
        sessionToken: token,
      });
    };

    doSignIn = (username = null, password = null, urlReferer = null) => httpClient.post(`${this.endpoint}/api/Login`, { username, password, urlReferer })
      .then((response) => {
        this.initInterceptor(response.data.sessionToken);
        return response;
      })
      .catch((error) => error);

    doVinDecode = (vin) => httpClient.post(`${this.endpoint}/api/Search/SuggestVehicleModels`, { vin });

    getVehicleYears = () => httpClient.post(`${this.endpoint}/api/LookupItems/VehicleYears`, {});

    getVehicleBrands = () => httpClient.post(`${this.endpoint}/api/LookupItems/VehicleBrands`, {});

    getVehicleModels = (vehicleYear, vehicleBrandID) => httpClient.post(`${this.endpoint}/api/LookupItems/VehicleModels`, {
      vehicleYear: parseInt(vehicleYear),
      vehicleBrandID,
    });

    getLocations = () => httpClient.post(`${this.endpoint}/api/LookupItems/Locations`, { });

    getPopularModels = () => httpClient.post(`${this.endpoint}/api/Search/PopularVehicleModels`, {});

    getValueGuidePlus = (VehicleModelID, vin, MonthsBack, Location, SoldOnly) => httpClient.post(`${this.membershipEndpoint}/api/Membership/ValueGuide`, {
      VehicleModelID, vin, MonthsBack, SoldOnly, LocationID: Location
    });

    getValueGuidePro = (vehicleModelID, Mileage, inspectionOptions,
      IncludeCharts = false, IncludeValues = true, IncludeComps = true, ValueLocation = null) => httpClient.post(`${this.membershipEndpoint}/api/ValueGuidePro/GetValueGuidePro`, {
      vehicleModelID,
      Mileage,
      IncludeCharts,
      IncludeValues,
      IncludeComps,
      ValueLocation,
      selectedInspectionOptions: Object.keys(inspectionOptions).map((key, i) => ({ name: key, rating: inspectionOptions[key] })),
    });

    getInspectionMaster = (vehicleModelID) => httpClient.post(`${this.membershipEndpoint}/api/ValueGuidePro/GetInspectionMaster`, { vehicleModelID })
}

export default AuctionCore;
